/**
 * What the product calls itself.
 *
 * Here, and shared, because more than one thing has to agree on it: the browser
 * tab, the name in front of every outgoing email address, and anything else that
 * has to introduce the product to somebody outside it. It was written down in
 * `api/src/email/sender.ts` alone, and the tab said "App".
 *
 * The product's own name, so it does not vary by who is reading it — the
 * sidebar's lockup says the same to everyone (see `AppLayout`). It was CS Venue
 * View until the FLOH Venues brand (2026-11); "FLOH" stands for For the Love of
 * Hospitality, is said "flow", and is always written in capitals.
 *
 * `web/index.html` carries a static copy in its `<title>`, because HTML cannot
 * import a constant. `web/src/app-identity.spec.ts` holds the two together.
 */
export const PRODUCT_NAME = 'FLOH Venues'
